import {UserErrorsFactory} from '../Errors/factory.js'
import {GetConversationUserParamsRequest} from './GetConversationUserRequest.js'
import {LeadHitUserRequest} from './LeadHitUserRequest.js'
import {SubscriptionsParamsRequest} from './SubscriptionsParamsRequest.js'
import {UpdateCurrentUserRequest} from './UpdateCurrentUserRequest.js'
import {UpdateDataUserRequest} from './UpdateDataUserRequest.js'
import {UpdatePasswordUserRequest} from './UpdatePasswordUserRequest.js'
import {ValidatePhoneVerificationCodeUserRequest} from './ValidatePhoneVerificationCodeUserRequest.js'

export class UserRequestsFactory {
  static leadHitUserRequestFactory = ({endpointUrl}) => new LeadHitUserRequest({endpointUrl})

  static getConversationUserParamsRequest = ({adId, partnerId, userId}) => {
    GetConversationUserParamsRequest.validate({
      adId,
      userId,
      userConversationError: UserErrorsFactory.getConversationUserError
    })

    return new GetConversationUserParamsRequest({
      adId,
      partnerId,
      userId
    })
  }

  static subscriptionsParamsRequest = ({newSubscriptions = {}, subscriptionType = '', userId = '', token = ''}) => {
    SubscriptionsParamsRequest.validate({
      userId,
      token,
      subscriptionsUserError: UserErrorsFactory.subscriptionsUserError
    })
    return new SubscriptionsParamsRequest({
      newSubscriptions,
      subscriptionType,
      userId,
      token
    })
  }

  static updateCurrentUserRequest = ({avatar, name, lastName, phone, provinceID, token, zipcode, zipCode}) => {
    return new UpdateCurrentUserRequest({
      avatar,
      name,
      lastName,
      phone,
      provinceID,
      token,
      zipCode: zipCode || zipcode
    })
  }

  static updateDataUserRequest = ({hidePhone, lastName, name, phone, zipCode}) => {
    return new UpdateDataUserRequest({
      hidePhone,
      lastName,
      name,
      phone,
      zipCode
    })
  }

  static updatePasswordUserRequest = ({newPassword, password}) => {
    UpdatePasswordUserRequest.validate({
      newPassword,
      password,
      userNotLoggedInUserError: UserErrorsFactory.userNotLoggedInUserError
    })

    return new UpdatePasswordUserRequest({
      newPassword,
      password
    })
  }

  static validatePhoneVerificationCodeUserRequest = ({code, phone}) => {
    ValidatePhoneVerificationCodeUserRequest.validate({
      code,
      phone,
      validatePhoneVerificationCodeError: UserErrorsFactory.validatePhoneVerificationCodeUserError
    })

    return new ValidatePhoneVerificationCodeUserRequest({code, phone})
  }
}
